"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldArray = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const isArray_1 = (0, tslib_1.__importDefault)(require("lodash/isArray"));
const useForm_1 = require("./hooks/useForm");
const FormFieldArray = ({ name, resetOnUnmount, children }) => {
    const { getValue, getField, push, remove, state, addField, removeField, store } = (0, useForm_1.useForm)();
    let fieldArray = getValue(name);
    if (fieldArray === null || fieldArray === undefined || !(0, isArray_1.default)(fieldArray)) {
        fieldArray = [];
    }
    let child = (0, react_1.useMemo)(() => {
        return children({
            fields: fieldArray.map((f, index) => `${name}[${index}]`),
            push: value => push(name, value),
            remove: (index) => remove(name, index),
            form: store
        });
    }, [fieldArray.length, name]);
    (0, react_1.useEffect)(() => {
        const field = getField(name);
        if (!field) {
            addField({ path: name });
        }
        return () => {
            removeField(name, resetOnUnmount);
        };
    }, []);
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: child }, void 0);
};
exports.FormFieldArray = FormFieldArray;
//# sourceMappingURL=FormFieldArray.js.map